/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint import/no-cycle: [1, { maxDepth: 1 }] */
import React, { useState, useEffect, useRef } from 'react';

// FOR AUTH FUNCTIONALITY API AND CONTEXT
import Cookies from 'js-cookie';

// ALL MATERIAL UI COMPONENTS AND THEME
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
} from '@material-ui/core';
import './LoginViaUsername.css';
// IMPORTING ICONS
import BanUser from '@features/UserAccountBan/components/UserAccountBan';
import LockUser from '@features/UserAccountLock';
import setSegmentIdentity from '@shared/utils/SetSegmentIdentity';
import unsetSegmentIdentity from '@shared/utils/UnsetSegmentIdentity';
import { sendVerifySMS as sendVerifySMSData, ssoLogin, userLoggedIn } from '@features/Authentication/services/authenticationApi';
// login form components
import OtpForm from './OtpForm';
import UsernameForm from './UsernameForm';
import LoginFooter from '../LoginFooter/LoginFooter';

const useStyles = makeStyles(() => ({
  loginModalTitle: {
    color: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    lineHeight: '28px',
    fontStyle: 'normal',
    minWidth: '300px',
    maxWidth: '300px',
    fontFamily: 'CircularXX-Bold, sans-serif !important',
    verticalAlign: 'top',
  },
  loginModalHeader: {
    color: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 24,
    fontFamily: 'CircularXX-Bold, sans-serif !important',
  },
  subtitle: {
    color: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 16,
    fontFamily: 'CircularXX-Book, sans-serif !important',
  },
  loginModalDescription: {
    color: '#ffffff',
    width: '320px',
    alignItems: 'center',
    fontWeight: '450',
    lineHeight: '18px',
    fontSize: '14px',
    fontFamily: 'CircularXX-Book',
    verticalAlign: 'top',
  },

}));
function LoginviaUsername({
  modalFunc,
  loggedInFunc,
  setMenuOption,
  setcheckUsernameFormPage,
  subLabelTextUsername,
  setSubLabelTextUsername,
  errorMessage,
  setErrorMessasge,
  showErrorMessage,
  setShowErrorMessage,
}) {
  // import the custom styles from useStyles
  const classes = useStyles();
  // ban and lock
  const [banModalStatus, setBanModalStatus] = useState(false);
  const [userBanDetails, setUserBanDetails] = useState([]);
  const [isBan, setIsBan] = useState(false);
  const [isLock, setIsLock] = useState(false);

  const [usernameVal, setUsernameVal] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [disableNext, setDisableNext] = useState(false);
  const [usernameHolder, setUsernameHolder] = useState('');
  const [disableResend, setDisableResend] = useState(false);
  const [timerActive, setTimerActive] = useState(false);
  const [otpMessage, setOtpMessage] = useState('');
  // countdown timer configuration
  const TimerRef = useRef(null);
  const [timer, setTimer] = useState('00:00');

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    return {
      total, minutes, seconds,
    };
  };
  // start the timer configuration
  const startTimer = (e) => {
    const {
      total, minutes, seconds,
    } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      const minutesVal = `0${minutes}`;
      const secondsVal = `0${seconds}`;
      setTimer(
        `${minutes > 9 ? minutes : minutesVal}:${
          seconds > 9 ? seconds : secondsVal}`,
      );
    }
    if (total === 0) {
      setTimerActive(false);
      setDisableResend(false);
    }
  };
  // clear the time
  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    setTimer('00:30');
    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (TimerRef.current) clearInterval(TimerRef.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    TimerRef.current = id;
  };

  // get the deadtime
  const getDeadTime = () => {
    const deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 30);
    return deadline;
  };
  // We put empty array to act as componentDid
  // mount only
  useEffect(() => {
    clearTimer(getDeadTime());
  }, []);

  useEffect(() => {
    setcheckUsernameFormPage('usernameField');
    setShowErrorMessage(false);
    setErrorMessasge('');
  }, []);
  // send verify sms function
  const verifyNotExistingUsername = async (response, msg) => {
    const btnElement = document.getElementById('next-btn');
    if (response.data.code === '500' && !msg.includes('locked')) {
      const usernameField = document.getElementById('username-form-id');
      usernameField.style.borderColor = '#E32B2B';
      setErrorMessasge('This username isn\'t related to any account');
      setShowErrorMessage(true);
      setDisableNext(false);
      btnElement.style.color = '#A4A7A9';
    } else if (response.data.code === '0' && !msg.includes('locked')) {
      const usernameField = document.getElementById('username-form-id');
      usernameField.style.borderColor = '#E32B2B';
      setErrorMessasge('Number of attempts exceeded. Try again later or try a different log in method');
      setShowErrorMessage(true);
      setDisableNext(false);
      btnElement.style.color = '#A4A7A9';
    }
  };
  const triggerAnimation = async () => {
    const divUsername = document.getElementById('username-form');
    const divOtp = document.getElementById('otp-form');
    divOtp.style.opacity = 0;
    divOtp.style.display = 'none';
    divUsername.addEventListener('animationend', (e) => {
      if (e.animationName === 'move-forward') {
        divUsername.classList.remove('move-forward');
        divUsername.style.display = 'none';
        divOtp.classList.add('move-right');
        divOtp.style.display = 'flex';
      }
    });
    divUsername.classList.add('move-forward');
    divOtp.addEventListener('animationend', (e) => {
      if (e.animationName === 'move-right') {
        divOtp.classList.remove('move-forward');
        divOtp.classList.remove('move-right');
        divOtp.style.display = 'flex';
        divOtp.style.opacity = 1;
      }
    });
  };
  const checkViolations = async (response) => {
    if (response.data.data.violations) {
      setUserBanDetails(response.data);
      setBanModalStatus(true);
      setIsBan(true);
      setDisableNext(false);
    }
  };
  const checkUsernameSimilarity = async () => {
    if (usernameVal && (usernameVal === usernameHolder)) {
      if (timerActive === true) {
        setDisableResend(true);
      } else if (timerActive === false) {
        setDisableResend(false);
      }
      setcheckUsernameFormPage('otpField');
      await triggerAnimation();
      setSubLabelTextUsername(otpMessage);
      return true;
    }
  };
  async function sendVerifySMS() {
    if (usernameVal && (usernameVal !== usernameHolder)) {
      setDisableNext(true);
      sendVerifySMSData(usernameVal)
        .then(async (response) => {
          msg = response.data.message ? response.data.message : 'Something went wrong. Please try again.';
          await verifyNotExistingUsername(response, msg);
          if (response.data.code === '200') {
            setTimerActive(true);
            setDisableResend(true);
            setUsernameHolder(usernameVal);
            clearTimer(getDeadTime());
            setcheckUsernameFormPage('otpField');
            setErrorMessasge('');
            setShowErrorMessage(false);
            setOtpCode('');
            const btnElementSubmit = document.getElementById('submit-btn');
            const otpfield = document.getElementById('otp-form-id');
            otpfield.style.borderColor = '#CED1D4';
            btnElementSubmit.style.color = '#A4A7A9';
            btnElementSubmit.classList.remove('btn-red');
            const newMsg = `Verification code sent to ${response.data.data.request_id}`;
            setTimeout(() => {
              setDisableNext(false);
            }, 1500);
            setSubLabelTextUsername(newMsg);
            setOtpMessage(newMsg);
            await triggerAnimation();
          } else if ((response.data.code === '0' || response.data.code === '500') && msg.includes('locked')) {
            setBanModalStatus(true);
            setIsLock(true);
            setDisableNext(false);
          } else if (!response.data.data.violations) {
            // login failed segment event
            window.analytics.track('Login Failed', {
              login_method: 'Username',
              error_message: msg,
            });
          }
          await checkViolations(response);
        }).catch((error) => {
          console.error(error);
          msg = error;
          setErrorMessasge('Something went wrong. Try again or try a different log in method.');
          setShowErrorMessage(true);
          setDisableNext(false);
          // login failed segment event
          window.analytics.track('Login Failed', {
            login_method: 'Username',
            error_message: error,
          });
        });
    } else if (usernameVal === '') {
      const usernameField = document.getElementById('username-form-id');
      usernameField.style.borderColor = '#E32B2B';
      setErrorMessasge('Provide username to proceed.');
      setShowErrorMessage(true);
      setDisableNext(false);
    }
    await checkUsernameSimilarity();
  }

  // captcha verification upon click of otp button
  let msg = '';
  const reSendOTP = () => {
    // eslint-disable-next-line prefer-const
    setOtpCode('');
    const btnElementSubmit = document.getElementById('submit-btn');
    const otpfield = document.getElementById('otp-form-id');
    otpfield.style.borderColor = '#CED1D4';
    btnElementSubmit.style.color = '#A4A7A9';
    btnElementSubmit.classList.remove('btn-red');
    if (usernameVal) {
      sendVerifySMSData(usernameVal)
        .then(async (response) => {
          msg = response.data.message ? response.data.message : 'Something went wrong. Please try again.';
          await verifyNotExistingUsername(response, msg);
          if (response.data.code === '200') {
            setTimerActive(true);
            clearTimer(getDeadTime());
            setDisableResend(true);
            setErrorMessasge('');
            setShowErrorMessage(false);
            const newMsg = `Verification code resent to ${response.data.data.request_id}`;
            setSubLabelTextUsername(newMsg);
            setOtpMessage(newMsg);
          } else if ((response.data.code === '0' || response.data.code === '500') && msg.includes('locked')) {
            setErrorMessasge('Your account has been locked for violating Kumunity guidelines. For questions, email support@kumu.ph.');
            setShowErrorMessage(true);
            setBanModalStatus(true);
            setIsLock(true);
          } else if (!response.data.data.violations) {
            // login failed segment event
            window.analytics.track('Login Failed', {
              login_method: 'Username',
              error_message: msg,
            });
          }
          if (response.data.data.violations) {
            setUserBanDetails(response.data);
            setBanModalStatus(true);
            setIsBan(true);
          }
        }).catch((error) => {
          console.error(error);
          msg = error;
          setErrorMessasge('Something went wrong. Try again or try a different log in method.');
          setShowErrorMessage(true);
          // login failed segment event
          window.analytics.track('Login Failed', {
            login_method: 'Username',
            error_message: error,
          });
        });
    } else {
      msg = 'Please enter your kumu Username';
      setSubLabelTextUsername(msg);
    }
  };

  function userProfile(userToken) {
    userLoggedIn(userToken)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === '200') {
            loggedInFunc({
              loggedIn: response.data.data,
              modalStatus: false,
            });
            modalFunc({
              modalStatus: false,
            });
            setMenuOption(false);
            Cookies.set('uid', response.data.data.user_id, { expires: 90, secure: true });
            // segment tracking
            if (process.env.REACT_APP_ON_SEGMENT === 'true') {
              // segment set identify call
              if (response.data.data.guid) {
                setSegmentIdentity(response.data.data.guid);
              // segment unset identify call
              } else {
                unsetSegmentIdentity();
              }
              // login success segment event
              window.analytics.track('Login Succeeded', {
                login_method: 'Username',
              });
            }
          }
        }
      });
  }
  const activateErrorMessage = (newErrorMessage) => {
    const otpFormField = document.getElementById('otp-form-id');
    otpFormField.style.borderColor = '#E32B2B';
    setErrorMessasge(newErrorMessage);
    setShowErrorMessage(true);
  };
  const errorMessageHelper = async (messageVal, newErrorMessage) => {
    const btnElementSubmit = document.getElementById('submit-btn');
    if (messageVal === 'The verification code is incorrect.') {
      btnElementSubmit.style.color = '#A4A7A9';
      btnElementSubmit.classList.remove('btn-red');
      activateErrorMessage(newErrorMessage);
    } else if (messageVal === 'Sorry, number of attempts exhausted. Please press resend to receive a new OTP.') {
      const message = 'Number of attempts exceeded. Press Resend Code to receive a new verification code.';
      btnElementSubmit.style.color = '#A4A7A9';
      btnElementSubmit.classList.remove('btn-red');
      activateErrorMessage(message);
    } else if (messageVal === 'Verification code is expired.') {
      const message = 'Code has expired. Press Resend Code to receive a new verification code.';
      activateErrorMessage(message);
      btnElementSubmit.style.color = '#A4A7A9';
      btnElementSubmit.classList.remove('btn-red');
    }
  };
  // login function
  const loginViaSSO = () => {
    if (otpCode && usernameVal) {
      const data = new URLSearchParams({
        username: usernameVal,
        otp: otpCode,
      });
      ssoLogin(data)
        .then(async (response) => {
          if (response.status === 200) {
            if (response.data.code === '200') {
              Cookies.set('token', response.data.data.access_token, { expires: 90, secure: true });
              const userToken = response.data.data.access_token;
              userProfile(userToken);
            } else if (response.data.code === '500') {
              msg = response.data.data.error_description;
              const messageVal = response.data.data.error_description;
              const newErrorMessage = 'Verification code is incorrect';
              await errorMessageHelper(messageVal, newErrorMessage);
              // login failed segment event
              window.analytics.track('Login Failed', {
                login_method: 'Username',
                error_message: msg,
              });
            }
          } else {
            msg = response.data.error_description;
            // login failed segment event
            window.analytics.track('Login Failed', {
              login_method: 'Username',
              error_message: msg,
            });
            setErrorMessasge('Something went wrong. Try again or try a different log in method');
            setShowErrorMessage(true);
          }
        })
        .catch((error) => {
          console.error(error);
          setErrorMessasge('Something went wrong. Try again or try a different log in method');
          setShowErrorMessage(true);
        });
    } else {
      const otpfield = document.getElementById('otp-form-id');
      otpfield.style.borderColor = '#E32B2B';
      setErrorMessasge('OTP is required for authentication');
      setShowErrorMessage(true);
    }
  };

  const renderBanOrLockModal = () => {
    if (isBan) {
      return (<BanUser banModalStatus={banModalStatus} userBanDetails={userBanDetails} />);
    } else if (isLock) {
      return (<LockUser banModalStatus={banModalStatus} />);
    }
  };

  const changeTextColor = (e) => {
    const btnElement = document.getElementById('next-btn');
    if (e.target.value !== '') {
      btnElement.style.color = 'black';
      setErrorMessasge('');
      setShowErrorMessage(false);
      const usernameField = document.getElementById('username-form-id');
      usernameField.style.borderColor = '#CED1D4';
    } else {
      btnElement.style.color = '#A4A7A9';
      setErrorMessasge('');
      setShowErrorMessage(false);
      const usernameField = document.getElementById('username-form-id');
      usernameField.style.borderColor = '#CED1D4';
    }
    setUsernameVal(e.target.value);
  };
  const changeSubmitColor = (e) => {
    const btnElementSubmit = document.getElementById('submit-btn');
    if (e.target.value !== '') {
      btnElementSubmit.style.color = '#fff';
      btnElementSubmit.classList.add('btn-red');
      setErrorMessasge('');
      setShowErrorMessage(false);
      const otpField = document.getElementById('otp-form-id');
      otpField.style.borderColor = '#CED1D4';
    } else {
      btnElementSubmit.style.color = '#A4A7A9';
      setErrorMessasge('');
      setShowErrorMessage(false);
      btnElementSubmit.classList.remove('btn-red');
      const otpField = document.getElementById('otp-form-id');
      otpField.style.borderColor = '#CED1D4';
    }
    setOtpCode(e.target.value);
  };

  const handleNextScreen = () => {
    sendVerifySMS();
  };

  useEffect(() => {
    // Event listener for the Enter key events on username field
    const usernameField = document.getElementById('username-form-id');
    const nextBtn = document.getElementById('next-btn');
    usernameField.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        nextBtn.click();
      }
    });
    // Event listener for the Enter key events on otp field
    const otpCodeField = document.getElementById('otp-form-id');
    const submitBtn = document.getElementById('submit-btn');
    otpCodeField.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        submitBtn.click();
      }
    });
  }, []);
  // implementation of the auto complete functionality
  useEffect(() => {
    if ('OTPCredential' in window) {
      const input = document.querySelector('input[autocomplete="one-time-code"]');
      if (!input) return null;
      const ac = new AbortController();
      if (otpCode !== '') {
        ac.abort();
      }
      navigator.credentials.get({
        otp: { transport: ['sms'] },
        signal: ac.signal,
      }).then((otp) => {
        input.value = otp.code;
        setOtpCode(otp.code);
        // Automatically submit the form when an OTP is obtained.
        setTimeout(() => {
          const submitBtn = document.getElementById('submit-btn');
          submitBtn.click();
        }, 1000);
      }).catch((err) => {
        console.error(err);
      });
    }
  }, []);
  return (
    <>
      <Grid
        item
        xs={12}
        align='center'
        style={{
          position: 'fixed',
          top: 90,
          left: 60,
          right: 60,
        }}
      >
        <Grid container justifyContent='center' alignItems='center'>
          <Typography
            className={classes.loginModalTitle}
            gutterBottom
          >
            Log in to kumu
          </Typography>
          <Typography
            variant='subtitle2'
            align='center'
            style={{
              fontSize: 14,
              color: '#fff',
              fontFamily: 'CircularXX-Book',
              maxWidth: 400,
              minWidth: 400,
            }}
          >
            {subLabelTextUsername}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        align='center'
        style={{
          position: 'fixed',
          top: 200,
          left: 60,
          right: 60,
        }}
      >
        <Grid container justifyContent='center' alignItems='center'>
          <div className='first-form' id='username-form'>
            <UsernameForm
              handleNextScreen={handleNextScreen}
              usernameVal={usernameVal}
              changeTextColor={changeTextColor}
              errorMessage={errorMessage}
              showErrorMessage={showErrorMessage}
              disableNextBtn={disableNext}
            />
          </div>
          <div className='second-form' id='otp-form'>
            <OtpForm
              changeSubmitColor={changeSubmitColor}
              errorMessage={errorMessage}
              showErrorMessage={showErrorMessage}
              otpCode={otpCode}
              loginViaSSO={loginViaSSO}
              sendOTP={reSendOTP}
              timer={timer}
              disableResend={disableResend}
            />
          </div>
        </Grid>
      </Grid>
      <LoginFooter loginModalDescription={classes.loginModalDescription} />
      { banModalStatus === false ? '' : renderBanOrLockModal() }
    </>
  );
}

export default LoginviaUsername;
